import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./EventConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 520,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 34px 34px",
  outline: "none",
  textAlign: "center",
};

export const CompleteEventConfirmModal = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
}) => (
  <Modal
    open={open}
    onClose={confirming ? undefined : onClose}
    aria-labelledby="complete-event-confirm-title"
  >
    <Box sx={modalStyle} className="event-confirm-modal">
      <button
        type="button"
        className="event-confirm-modal__close"
        onClick={onClose}
        disabled={confirming}
        aria-label="Close"
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </button>

      <h2 id="complete-event-confirm-title">Mark event as completed?</h2>
      <p className="event-confirm-modal__body event-confirm-modal__body--tight">
        Once this event is marked completed, it cannot be undone.
      </p>
      <ul className="event-confirm-modal__outcomes">
        <li>Invite Accepted employees become Promotion Completed.</li>
        <li>
          Invite Sent employees return to Contact Pending and are removed from
          this event.
        </li>
        <li>
          Invite Rejected employees move to Contact Pending and can join other
          events, while staying marked Rejected on this list for the record.
        </li>
      </ul>

      <div className="event-confirm-modal__actions">
        <Button
          type="button"
          variant="outlined"
          className="event-confirm-modal__btn-secondary"
          onClick={onClose}
          disabled={confirming}
        >
          Go Back
        </Button>
        <Button
          type="button"
          variant="contained"
          className="event-confirm-modal__btn-primary"
          disableElevation
          onClick={onConfirm}
          disabled={confirming}
        >
          {confirming ? "Completing…" : "Mark as Completed"}
        </Button>
      </div>
    </Box>
  </Modal>
);
